import React, { useState } from 'react'
import { withTheme } from 'theming'
import AddSection from '../addSection'
import EditMenu from '../editMenu'
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu'
import useTemplateHook from '../templateHook'
import { isEmpty } from 'lodash'

const CategoryNavigator = ({
  componentData,
  modifyData,
  setModalState,
  isEdit,
  onSwap,
  onDelete,
  onCopy,
  theme,
  onAdd,
}) => {
  const { data, id } = componentData

  const { KalingoLeftArrow, KalingoRightArrow } = useTemplateHook()
  const [hoverState, setHoverState] = useState('')
  const [hoverCategory, setHoverCategory] = useState('')

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }
  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey].data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  const getCategoryBgColor = (categoryKey) => {
    if (!data?.style_config) {
      return ''
    }

    if (categoryKey === hoverCategory) {
      return getStyleValue('category_style', 'hover_color', '')
    }
    return getStyleValue('category_style', 'default_color', '#11171f')
  }

  function LeftArrow() {
    const { isFirstItemVisible, scrollPrev } = React.useContext(VisibilityContext)
    return (
      <button
        className={`absolute left-0 z-10 bg-transparent px-0 hidden lg:flex justify-center ${
          isFirstItemVisible ? 'opacity-0' : 'opacity-100'
        } `}
        disabled={isFirstItemVisible}
        onClick={() => scrollPrev()}
        title="Previous Item"
        style={{ width: '3.66032%', top: '5%' }}
      >
        <img src={KalingoLeftArrow} style={{ height: '37px' }} alt="KalingoLeftArrow" />
      </button>
    )
  }

  function RightArrow() {
    const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext)
    return (
      <button
        className={`absolute right-0 z-10 bg-transparent px-0 hidden lg:flex justify-center ${
          isLastItemVisible ? 'opacity-0' : 'opacity-100'
        }`}
        disabled={isLastItemVisible}
        onClick={() => scrollNext()}
        title="Next Item"
        style={{ width: '3.66032%', top: '5%' }}
      >
        <img src={KalingoRightArrow} style={{ height: '37px' }} alt="KalingoLeftArrow" />
      </button>
    )
  }
  return (
    <div
      className={`w-full relative ${isEdit && hoverState && 'component-hover-class'}`}
      style={{
        backgroundColor: getStyleValue('component_background', 'primary_color', ''),
      }}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onDelete={() => onDelete(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
          onEdit={() => handleModal()}
          onCopy={() => onCopy(id)}
        />
      )}
      <div className="py-[10px] lg:py-4">
        <h2
          style={{
            color: getStyleValue('heading', 'color', '#ffffff'),
            padding: '0px 3.66032%',
          }}
          className={`xl:text-2xl md:text-xl text-xs font-semibold`}
        >
          {data?.title}
        </h2>
        <div
          style={{
            padding: '0px 3.66032%',
          }}
          className="w-full mt-2 md:mt-4 relative"
        >
          <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow} wrapperClassName="w-full">
            {data?.card_data &&
              [...data?.card_data].map((info, index) => (
                <CategoryCard
                  key={index}
                  itemId={`index${index}`}
                  index={index}
                  info={info}
                  setHoverCategory={setHoverCategory}
                  getCategoryBgColor={getCategoryBgColor}
                  getStyleValue={getStyleValue}
                />
              ))}
          </ScrollMenu>
        </div>
      </div>
      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
    </div>
  )
}

function CategoryCard({ index, info, setHoverCategory, getCategoryBgColor, getStyleValue }) {
  const { customNavigate } = useTemplateHook()

  const handleRedirect = (linkObj) => {
    customNavigate('INDIRECT', linkObj)
  }
  return (
    <div
      style={{
        backgroundColor: getCategoryBgColor(info.category_key),
        color: getStyleValue('category_style', 'text_color', '#eaeaea'),
        border: `1px solid ${getStyleValue('category_style', 'border_color', '#727272')}`,
      }}
      key={index}
      className={`cursor-pointer flex items-center justify-center text-[10px] lg:text-xs rounded xl:rounded-md w-[96.4px] lg:w-[183px] h-[22px] lg:h-[40px] ${
        index && 'ml-2.5 lg:ml-6'
      }`}
      onClick={() => {
        handleRedirect(info.link)
      }}
      onMouseOver={() => setHoverCategory(info.category_key)}
      onMouseLeave={() => setHoverCategory('')}
    >
      {info.category_name}
    </div>
  )
}

export default withTheme(CategoryNavigator)
